import useLocalize from '../../../../utils/hooks/useLocalize';
import getCellValue from './getCellValue';

const i18nKeyPrefix = 'symbol.details.margin.information.';

const SectionRow = ({ data, rowIndex = 0 }) => {
  const localize = useLocalize();

  const title = data.title ? (
    <div className="credit-info-table-cell-title">
      {localize(i18nKeyPrefix + data.title)}
    </div>
  ) : null;

  const lastColumnIndex = data.values.length - 1;

  return (
    <div
      className={`credit-info-table-row ${rowIndex % 2 === 0 ? 'even' : 'odd'}`}
    >
      {title}
      {data.values.map((e, i) => getCellValue(e, i, i === lastColumnIndex))}
    </div>
  );
};

export default SectionRow;
